import React from 'react';
import PropTypes from 'prop-types';
import { HideOnMobile, ProgressBar } from '@web/atoms';
import { BaseHeader, PromoPill, DiscountBanner } from '@web/molecules';
import {
  BreadcrumbContainer,
  CurrentProgress,
  PromoPillContainer,
} from './styles';

export const QuizHeaderOptimized = ({
  currentStep,
  totalSteps,
  showPromoBar,
  discountBannerCopy,
  discountBannerBGColor,
  discountBannerFontColor,
  cro = true,
  progress = true,
  overrideText = '',
}) => {
  const rightHeaderSegment = (
    <HideOnMobile>
      {showPromoBar && (
        <PromoPillContainer>
          <PromoPill />
        </PromoPillContainer>
      )}
    </HideOnMobile>
  );

  const topHeaderSegment = (
    <>
      {showPromoBar && (
        <DiscountBanner
          promoMessage={discountBannerCopy}
          bgColor={discountBannerBGColor}
          fontColor={discountBannerFontColor}
          showLink={false}
        />
      )}
      <BreadcrumbContainer>
        <CurrentProgress>
          {overrideText ? (
            <span>{overrideText}</span>
          ) : (
            <span>
              Step {currentStep} of {totalSteps}
            </span>
          )}
        </CurrentProgress>
        {progress && (
          <ProgressBar
            color="secondary.pallette"
            currentStep={currentStep}
            totalSteps={totalSteps}
            labelText={`Signup step ${currentStep} of ${totalSteps}`}
          />
        )}
      </BreadcrumbContainer>
    </>
  );

  return (
    <BaseHeader
      sticky={true}
      stickyBanner={true}
      cro={cro}
      topSegment={topHeaderSegment}
      rightSegment={rightHeaderSegment}
      withDropShadow={true}
    />
  );
};

QuizHeaderOptimized.displayName = 'QuizHeaderOptimized';

QuizHeaderOptimized.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  showPromoBar: PropTypes.bool,
  discountBannerCopy: PropTypes.string,
  discountBannerBGColor: PropTypes.string,
  discountBannerFontColor: PropTypes.string,
  cro: PropTypes.bool,
  progress: PropTypes.bool,
  overrideText: PropTypes.string,
};
